import { BlockedCreator } from "@next-platform/client-common-core";
import { Button, ButtonSize, ButtonVariant } from "@next-platform/client-common-spicy-ui";

import { Row } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

import BlockedCreatorListItem from "./BlockedCreatorListItem";

type BlockedCreatorsListProps = {
  blockedCreators: BlockedCreator[];
  hasMoreBlockedCreators: boolean;
  isLoading: boolean;
  onLoadMorePress: () => void;
  onUnblockPress: ({ creatorId, username }: { creatorId: string; username: string }) => void;
  "data-testid"?: string;
};

const BlockedCreatorsList = ({
  blockedCreators,
  hasMoreBlockedCreators,
  isLoading,
  onLoadMorePress,
  onUnblockPress,
  "data-testid": testId = "BlockedCreatorsList",
}: BlockedCreatorsListProps) => {
  return (
    <div data-testid={testId}>
      {blockedCreators.map((creator, creatorIndex) => (
        <BlockedCreatorListItem key={creator.id} creator={creator} creatorIndex={creatorIndex} onUnblockPress={onUnblockPress} />
      ))}
      {hasMoreBlockedCreators ? (
        <Row justify="center" className="my-lg">
          <Button
            loading={isLoading}
            onClick={onLoadMorePress}
            size={ButtonSize.LARGE}
            variant={ButtonVariant.OUTLINED}
            data-testid="BlockedCreators-LoadMoreButton"
          >
            <Trans i18nKey="common:loadMore" />
          </Button>
        </Row>
      ) : null}
    </div>
  );
};

export default BlockedCreatorsList;
